module.exports = __webpack_public_path__ + "static/media/nophoto.d1bef577.png";